import { render, staticRenderFns } from "./LandingINTBabyShower.vue?vue&type=template&id=479e40c5&scoped=true"
import script from "./LandingINTBabyShower.vue?vue&type=script&lang=js"
export * from "./LandingINTBabyShower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e40c5",
  null
  
)

export default component.exports